import { Alert, Checkbox, FormControlLabel, Paper } from "@mui/material";
import { ExtraConfigsCalibrationSubform } from "../../ExtraConfigsCalibrationSubform";
import { GpsOffsetCalibrationSubform } from "../../GpsOffsetCalibrationSubform";
import { SteeringValveCalibrationSubform } from "../../SteeringValveCalibrationSubform";
import { StepProps } from "./StepProps";
import { TractorArchetypeViewModel } from "../TractorArchetypeViewModel";
import { typedPath } from "typed-path";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import React from "react";

const S = typedPath<TractorArchetypeViewModel>();

export const CalibrationStep: React.FC<StepProps> = ({ disabled }) => {
  const { t } = useTranslation();
  const { values, setFieldValue } =
    useFormikContext<TractorArchetypeViewModel>();
  return (
    <div className="flex flex-col gap-2">
      <Paper className="flex flex-col gap-4 p-4">
        <FormControlLabel
          label={t(
            "views.autotractor.equipment.tractors.provideDefaultCalibrationData"
          )}
          checked={values.calibration.present}
          disabled={disabled}
          control={<Checkbox />}
          onChange={() =>
            setFieldValue("calibration.present", !values.calibration.present)
          }
        />
        <Alert className="col-span-full" severity="warning">
          {t("views.autotractor.equipment.tractors.globalSettingWarning")}
        </Alert>
      </Paper>
      <GpsOffsetCalibrationSubform
        basePath={S.calibration.value}
        readOnly={disabled || !values.calibration.present}
      />
      <SteeringValveCalibrationSubform
        basePath={S.calibration.value}
        readOnly={disabled || !values.calibration.present}
      />
      <ExtraConfigsCalibrationSubform
        basePath={S.calibration.value}
        driveType={values.driveType}
        values={values.calibration.value}
        readOnly={disabled || !values.calibration.present}
      />
    </div>
  );
};
